import { render, staticRenderFns } from "./MemberForm.vue?vue&type=template&id=30dca965&scoped=true"
import script from "./MemberForm.vue?vue&type=script&lang=js"
export * from "./MemberForm.vue?vue&type=script&lang=js"
import style0 from "./MemberForm.vue?vue&type=style&index=0&id=30dca965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dca965",
  null
  
)

export default component.exports